import * as firebase from 'firebase/app';

// import 'firebase/auth';
// import 'firebase/analytics';
import 'firebase/firestore';
// import 'firebase/storage';
// import { APP_STATE_ACTION_TYPE_USER_LOCALE } from '../state/seed-states';

class UserApi {
  constructor(firebaseConfig, state) {
    this.state = state;
    if (!firebase.apps.length && firebaseConfig) {
      const { firebaseOptions, ...restFirebaseConfig } = firebaseConfig;
      this.firebase = firebase.initializeApp(restFirebaseConfig);
    } else {
      // eslint-disable-next-line prefer-destructuring
      this.firebase = firebase.apps[0];
    }
    if (firebaseConfig.firebaseOptions) {
      if (firebaseConfig.firebaseOptions.firestore) {
        this.db = this.firebase.firestore();
      }
    }
    this.table = 'users';
  }

  getAll() {
    const p = new Promise((resolve, reject) => {
      if (this.db) {
        this.db.collection(this.table).get().then((querySnapshot) => {
          const data = [];
          querySnapshot.forEach((doc) => {
            const d = doc.data();
            data.push({ ...d, id: doc.id });
            // console.log(`${doc.id} => ${doc.data()}`);
          });
          resolve({
            data: {
              data: {
                success: true,
                payload: data,
              },
            },
          });
        });
      } else {
        reject(new Error('Firestore is not initialized'));
      }
    });
    return p;
  }

  getByUsername(username) {
    const p = new Promise((resolve, reject) => {
      if (this.db) {
        const usersRef = this.db.collection(this.table);
        usersRef.where('username', '==', username).get().then((querySnapshot) => {
          let user;
          querySnapshot.forEach((doc) => {
            user = doc.data();
          });
          resolve({
            data: {
              data: {
                success: true,
                payload: user,
              },
            },
          });
        });
      } else {
        reject(new Error('Firestore is not initialized'));
      }
    });
    return p;
  }

  setupUser(userId, initialUserData) {
    const p = new Promise((resolve, reject) => {
      if (this.db) {
        const docRef = this.db.collection(this.table).doc(userId);
        docRef.get().then((doc) => {
          if (doc.exists) {
            resolve({
              data: {
                data: {
                  success: true,
                  message: 'User is already set up!',
                  payload: doc.data(),
                },
              },
            });
          } else {
            docRef.set(initialUserData)
              .then(() => {
                resolve({
                  data: {
                    data: {
                      success: true,
                      message: 'User successfully setup!',
                      payload: initialUserData,
                    },
                  },
                });
              }).catch((error) => {
                reject(new Error(error.message));
              });
          }
        }).catch((error) => {
          reject(new Error(error.message));
        });
      } else {
        reject(new Error('Firestore is not initialized'));
      }
    });
    return p;
  }
}

export default UserApi;
